import React from 'react'
import { Switch, Route } from 'react-router-dom'

import AddDriver from './AddDriver'
import RemoveDriver from './RemoveDriver'
import RemoveDriverConfirmation from './RemoveDriver/RemoveConfirmation'
import Action from './Action'
import AddVehicle from './AddVehicle'
import RemoveVehicleConfirmation from './RemoveVehicle/RemoveConfirmation'
import RemoveVehicle from './RemoveVehicle'

const routes = () => {
  return (
    <Switch>
      <Route path='/changepolicy/vehicle/driver/add' component={AddDriver} />
      <Route
        path='/changepolicy/vehicle/driver/remove/confirmation'
        component={RemoveDriverConfirmation}
      />
      <Route path='/changepolicy/vehicle/driver/remove' component={RemoveDriver} />
      <Route path='/changepolicy/vehicle/add' component={AddVehicle} />
      <Route
        path='/changepolicy/vehicle/remove/confirmation'
        component={RemoveVehicleConfirmation}
      />
      <Route path='/changepolicy/vehicle/remove' component={RemoveVehicle} />
      <Route path='/changepolicy/vehicle' component={Action} />
    </Switch>
  )
}

export default routes
